import { render, staticRenderFns } from "./TestPriceResult.vue?vue&type=template&id=2af39037&scoped=true"
import script from "./TestPriceResult.vue?vue&type=script&lang=js"
export * from "./TestPriceResult.vue?vue&type=script&lang=js"
import style0 from "./TestPriceResult.vue?vue&type=style&index=0&id=2af39037&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af39037",
  null
  
)

export default component.exports